import React from "react";
import Script from "@gumgum/react-script-tag";
import "./bamboo.css";

const BambooPositions = class extends React.Component {
  _triggerBamboo = () => {
    document.dispatchEvent(new Event("readystatechange"));
  };

  render() {
    return (
      <>
        <Script
          id="bambooScript"
          src="https://scriptdrop.bamboohr.com/js/jobs2.php"
          type="text/javascript"
          onLoad={this._triggerBamboo}
        ></Script>
        <div id="BambooHR">
          <div id="BambooHR-ATS">
            <div className="p-8 text-center text-accent-p1">
              <em>Loading...</em>
            </div>
          </div>
          <div id="BambooHR-Footer">
            Powered by
            <a
              href="http://www.bamboohr.com"
              target="_blank"
              rel="noopener external nofollow noreferrer"
            >
              <img
                src="https://resources.bamboohr.com/images/footer-logo.png"
                alt="BambooHR - HR software"
              />
            </a>
          </div>
        </div>
      </>
    );
  }
};

export default BambooPositions;
